import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import PlayerHeadshot from "../PlayerHeadshot";
import { getLastName } from "../../utils/textUtils";
import { colors } from "../../theme";
import PlayerNameLink from "../fanPage/PlayerNameLink";

const FormationLineupRow = ({
  slot,
  player,
  sport,
  editable = false,
  onSelect,
  onClear,
}) => {
  const filled = Boolean(player?.playerId);
  const clickable = editable || filled;

  return (
    <Box
      onClick={clickable ? () => onSelect?.(slot) : undefined}
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "40px 56px minmax(0, 1fr) auto",
          sm: "52px 64px minmax(0, 1fr) auto",
        },
        alignItems: "center",
        gap: { xs: 1.25, sm: 2 },
        px: { xs: 1.5, sm: 2 },
        py: 0.75,
        cursor: clickable ? "pointer" : "default",
        borderBottom: `1px solid ${colors.border}`,
        "&:last-of-type": { borderBottom: 0 },
        "&:hover": {
          bgcolor: editable ? "rgba(255,255,255,0.04)" : undefined,
        },
      }}
    >
      <Box>
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: { xs: 16, sm: 18 },
            lineHeight: 1,
            letterSpacing: "-0.03em",
          }}
        >
          {slot.short}
        </Typography>
      </Box>
      <Box
        sx={{
          width: { xs: 44, sm: 52 },
          height: { xs: 44, sm: 52 },
          borderRadius: "50%",
          border: filled
            ? `2px solid ${colors.positive}`
            : `2px dashed ${colors.border}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: filled ? "rgba(34, 197, 94, 0.08)" : "rgba(255,255,255,0.03)",
        }}
      >
        {filled ? (
          <PlayerHeadshot
            playerId={player.playerId}
            src={player.photoUrl}
            sport={sport}
            size={40}
            showTooltip={false}
            showLoading={false}
          />
        ) : (
          <AddIcon sx={{ color: editable ? "text.secondary" : "transparent" }} />
        )}
      </Box>
      <Box
        sx={{
          minWidth: 0,
          ...(filled && {
            display: "flex",
            alignItems: "center",
            gap: 1,
          }),
        }}
      >
        {filled ? (
          <PlayerNameLink
            playerId={player.playerId}
            name={getLastName(player.name)}
            sport={sport}
            linkable={player.linkable !== false}
          />
        ) : (
          <Typography variant="body1" fontWeight={700} noWrap>
            {editable ? `Pick ${slot.label}` : "Open"}
          </Typography>
        )}
        <Typography variant="caption" color="text.secondary" noWrap>
          {filled ? player.years || player.team || slot.label : slot.label}
        </Typography>
      </Box>
      {editable && filled && (
        <IconButton
          size="small"
          aria-label={`Clear ${slot.label}`}
          onClick={(event) => {
            event.stopPropagation();
            onClear?.(slot);
          }}
        >
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      )}
    </Box>
  );
};

export default FormationLineupRow;
